import React, { forwardRef } from "react";
import NewsCard from "../news/NewsCard";

const getNewsKey = (item, index) =>
  item?.id ?? item?.link ?? `${index}-${item?.title || ""}`;

const SavedPagerPage = forwardRef(
  (
    {
      filter,
      pageItems = [],
      className = "",
      onScroll,
      favicons = {},
      onMarkAsRead,
      onNewsOpen,
      savedLinks,
      onToggleSaved,
      onShare,
      onView,
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={`most-visited-pager__page saved-pager__page ${className}`.trim()}
        onScroll={onScroll}
        data-saved-filter={filter}
      >
        {pageItems.length === 0 ? (
          <div className="status-message">
            خبری در این دسته ذخیره نشده است
          </div>
        ) : (
          pageItems.map((item, index) => (
            <NewsCard
              key={getNewsKey(item, index)}
              news={item}
              favicon={favicons[item.source]}
              onVisible={() => {
                if (item?.link) {
                  onMarkAsRead?.(item.link, item.source);
                }
              }}
              onOpen={onNewsOpen}
              isSaved={item?.link ? savedLinks?.has(item.link) : false}
              onToggleSaved={onToggleSaved}
              onShare={onShare}
              onView={onView}
              mobileDividerEdge="bottom"
            />
          ))
        )}
      </div>
    );
  }
);

SavedPagerPage.displayName = "SavedPagerPage";

export default SavedPagerPage;
